$( function() {
	setSameHeight();
	initAccordion();
	openAccordionLocation();
});
function initAccordion() {
	$('.content-accordion').slideUp();
	$('.heading').on('click', function(e) {
		$('.heading').not($(this)).removeClass('open');
		$(this).toggleClass('open');
		var el = $(this).next('.content-accordion');

		var vis = el.is(':visible');
		$('.content-accordion').slideUp();
		if (vis) {
			el.slideUp();
		} else {
			el.slideDown();
			var topVal = 270;			
			if($(window).width() < 768) {
				topVal = 200;
			}
			setTimeout(function () {
				$('html, body').animate({
					scrollTop: el.offset().top - topVal
				}, 0); // Adjust the speed as needed
			}, 500);
		}		
	});

	
}

function setSameHeight() {
	if(window.innerWidth < 768) {
		var elements = document.querySelectorAll('.content-accordion .post-wrap');
		var tallestHeight = 0;
		elements.forEach(function(element) {
			var elementHeight = element.clientHeight;        
			if (elementHeight > tallestHeight) {
				tallestHeight = elementHeight;
			}
		});
		elements.forEach(function(element) {
			element.style.height = tallestHeight + 'px';
		});
	}
}


function openAccordionLocation() {
    var location = window.location.hash;

    // Check if the location hash exists
    if (location) {
        // Find the element with the ID that matches the location hash
        var targetElement = document.getElementById(location.substring(1));
		console.log(targetElement);
        // If the target element exists, find its closest heading
        if (targetElement) {
            var heading = targetElement.closest('.item').querySelector('.heading');

            // If the heading exists, trigger a click event on it
            if (heading) {
				setTimeout(function () {
                	heading.click();
				}, 600);
            }
        }
    }


}